import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";
import { Grid, Button, TextField, Paper } from "@material-ui/core";
import { Add, Delete } from "@material-ui/icons";
import get from "lodash/get";
import { fundAddAttribute } from "store/state/fund";
import styled from "styled-components";

const AddPaper = styled(Paper)`
  && {
    padding: 5px 0 20px;
    margin-top: 20px;
  }
`;
const AddDiv = styled.div`
  width: 50%;
`;
const AddDivAction = styled.div`
  margin: 15px 0 30px;
`;

class SubCategory extends React.Component {
  state = {
    add: false,
    name: "",
    reference: "",
    description: ""
  };

  handleAddAttribute = () => {
    // Trigger update to connected function to add key to avp subcat
    this.setState({
      add: true
    });
  };

  handleCancelAttribute = () => {
    // Trigger update to connected function to add key to avp subcat
    this.setState({
      add: false
    });
  };

  handleSaveAttribute = () => {
    const { name, reference, description } = this.state;
    const { match, formik } = this.props;

    // Update store with new attribute
    const payload = {
      fundId: match.params.fundId,
      category: "Fund Information",
      subCategory: this.props.subCategoryName,
      name,
      reference,
      description
    };

    formik.setFieldValue(
      `avps["Fund Information"]["${this.props.subCategoryName}"]["${name}"]`,
      { description: "", reference: "" }
    );

    // update store
    this.props.fundAddAttribute(payload);

    // reset state
    this.setState({ name: "", description: "", reference: "", add: false });
  };

  handleChange = ({ target: { name, value } }) => {
    this.setState({
      [name]: value
    });
  };

  render() {
    const { fund, formik, data, subCategoryName } = this.props;
    const { name } = this.state;

    return (
      <Grid container classes={{ container: "FormGroup" }}>
        <Grid className="header_Striped_Left" item xs={12}>
          <h4 id={`avps["Fund Information"]["${subCategoryName}"]`}>
            {subCategoryName}
          </h4>
        </Grid>
        <Grid item xs={12} className="row">
          {Object.keys(data).map(keyName => (
            <div className="avp-section" key={keyName}>
              <div className="avp-label">{keyName}</div>
              <TextField
                key={`${keyName}-description`}
                label="description"
                className="avps_FieldsTextarea avp-item"
                type="text"
                multiline
                rowsMax="10"
                margin="normal"
                // eslint-disable-next-line
                name={`avps["Fund Information"]["${subCategoryName}"]["${keyName}"].description`}
                defaultValue={get(
                  fund,
                  [
                    "avps",
                    "Fund Information",
                    subCategoryName,
                    keyName,
                    "description"
                  ],
                  ""
                )}
                onChange={formik.handleChange}
              />
              <TextField
                key={`${keyName}-reference`}
                label="reference"
                className="avps_FieldsTextarea avp-item"
                type="text"
                multiline
                rowsMax="10"
                margin="normal"
                // eslint-disable-next-line
                name={`avps["Fund Information"]["${subCategoryName}"]["${keyName}"].reference`}
                defaultValue={get(
                  fund,
                  [
                    "avps",
                    "Fund Information",
                    subCategoryName,
                    keyName,
                    "reference"
                  ],
                  ""
                )}
                onChange={formik.handleChange}
              />
            </div>
          ))}
          {!this.state.add && (
            <AddDivAction>
              <Button
                variant="raised"
                color="secondary"
                onClick={this.handleAddAttribute}
              >
                <Add />
                Add Item
              </Button>
            </AddDivAction>
          )}
          {this.state.add && (
            <AddDiv>
              <AddPaper>
                <div className="avp-item avps_FieldsTextarea">
                  <h4>Add Item</h4>
                </div>
                <TextField
                  label="key name"
                  className="avps_FieldsTextarea avp-item"
                  type="text"
                  multiline
                  rowsMax="10"
                  margin="normal"
                  value={name}
                  onChange={this.handleChange}
                  // eslint-disable-next-line
                  name={`name`}
                />
                <div className="avps_FieldsTextarea">
                  <Button
                    disabled={!name}
                    variant="raised"
                    color="primary"
                    onClick={this.handleSaveAttribute}
                  >
                    <Add />
                    Add
                  </Button>
                  <Button variant="raised" onClick={this.handleCancelAttribute}>
                    <Delete />
                    Cancel
                  </Button>
                </div>
              </AddPaper>
            </AddDiv>
          )}
        </Grid>
      </Grid>
    );
  }
}

const mapStateToProps = state => {
  const { loading } = state;
  return {
    loading
  };
};

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    { fundAddAttribute }
  )
)(SubCategory);
